/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
export const environment = {
  production: true,
  _apiUrl: "https://adm.api.ocr.escotta.com",
  eaClientId: 'a1e05137-6615-4407-a556-9434db182d45',
  tenantId: 'c9cb17f2-b2a4-4066-b514-6ef3b0d297fb',
  company: 'escotta',
  defaultDbClientId: 1,

  get apiUrl() {
    const path = window.location.pathname.slice(0, -1);
    return this._apiUrl + path;
  }
};
